import {
  faEye,
  faEyeSlash,
  faTrash,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import { MdModeEdit } from "react-icons/md";
import { useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";
import DefaultAgency from "../../../assets/img/defaultagency/default-agency.png";
import DynamicTable from "../../../components/Tables";
import {
  createAdmin,
  deleteAdminCall,
  getAgencyById,
  uploadAgencyLogo,
} from "../../../services/apis";

const UsersList = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [usersData, setUsersData] = useState([]);
  const [createAdminModal, setCreateAdminModal] = useState(false);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [deleteUser, setDeleteUser] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [fileUploadModal, setFileUploadModal] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [currentLogo, setCurrentLogo] = useState("");

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const location = useLocation();
  // const navigate = useNavigate();
  let currentAgencyLogo;
  const currentAgencyData = location.state?.AgencyData;
  currentAgencyLogo = currentAgencyData?.agencylogo;
  console.log("enter2==>", currentAgencyData);

  const queryParams = new URLSearchParams(location.search);
  console.log("eeeeq", queryParams);

  const agencyId = currentAgencyData?.agencyid;
  // const agencyName = decodeURIComponent(queryParams.get("agencyName"));
  // const address = decodeURIComponent(queryParams.get("address"));
  // let agencylogo = decodeURIComponent(queryParams.get("agencylogo"));
  console.log("Agency ID hi:", agencyId);

  // console.log("immggg", agencylogo);

  const cols = [
    {
      id: "serial",
      title: "S.No",
      key: "serial",
      isSortable: false,
      render: (_, index, { currentPage, itemsPerPage }) =>
        (currentPage - 1) * itemsPerPage + index + 1,
    },
    {
      id: "username",
      title: "User List",
      iskey: true,
      key: "username",
      isSortable: true,
      render: (value) => value,
    },
    {
      id: "email",
      title: "Email",
      iskey: true,
      key: "email",
      isSortable: true,
      render: (value) => value,
    },
    {
      id: "role",
      title: "Role",
      iskey: true,
      key: "role",
      isSortable: true,
      render: (value) => (value === "admin" ? "Admin" : "System User"),
    },
    {
      id: "createdon",
      title: "Created On",
      key: "createdon",
      isSortable: true,
      iskey: true,
      render: (value) => {
        const date = new Date(value);
        return !isNaN(date)
          ? date.toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })
          : "Invalid Date";
      },
    },

    {
      id: "active",
      title: "Status",
      key: "active",
      render: (row) => (
        <span
          className={`d-inline-flex align-items-center px-2 py-1 rounded fw-bold ${
            row.active ? "bg-success text-white" : "bg-danger text-white"
          }`}
          style={{ fontSize: "0.80rem", lineHeight: "0.9rem" }}
        >
          {row.active ? "Active" : "Inactive"}
        </span>
      ),
    },

    {
      id: "action",
      title: "Action",
      key: "userid",
      render: (value) => (
        <>
          {value.role === "admin" ? (
            <div className=" cursor-pointer">
              <div
                onClick={() => {
                  console.log("value", value);
                  setSelectedUserId(value);
                  setDeleteUser(true);
                }}
              >
                <FontAwesomeIcon
                  icon={faTrash}
                  style={{ cursor: "pointer", color: "red" }}
                />
              </div>
            </div>
          ) : null}
        </>
      ),
    },
  ];

  const adminExists = usersData.some((user) => user.role === "admin");

  const fetchUsers = async (agencyId) => {
    if (!agencyId) return;
    setIsLoading(true);
    const response = await getAgencyById(agencyId);
    setIsLoading(false);
    setCurrentLogo(response.data.agencylogo);
    // console.log("lkl", agencylogo);

    if (response && response.statuscode === 1) {
      setUsersData(response.users);
    }
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const validImageTypes = [
        "image/jpeg",
        "image/png",
        // "image/gif",
        "image/webp",
        "image/svg",
      ];
      if (!validImageTypes.includes(file.type)) {
        toast.error("Only image files are allowed (jpg, png, svg, etc.)");
        return;
      }
      setUploadedFile(file);
    }
  };

  const handleFileRemove = () => {
    setUploadedFile(null);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (uploadedFile) {
      setIsUploading(true);
      await uploadFile(uploadedFile);
      setIsUploading(false);
      // setFileUploadModal(false);
    } else {
      toast.dismiss();
      toast.error("Please select a file before submitting.");
    }
  };

  const uploadFile = async (file) => {
    if (!agencyId) {
      toast.dismiss();
      toast.error("Please select an agency before uploading the file.");
      return;
    }

    const formData = new FormData();
    formData.append("AgencyLogo", file);

    try {
      const response = await uploadAgencyLogo(agencyId, formData);
      console.log(response);
      if (response && response.statuscode === 1) {
        toast.dismiss();
        toast.success(response.message);
        setFileUploadModal(false);
        fetchUsers(agencyId);
      } else {
        toast.dismiss();
        toast.warning(response.message || "Error In Uploading Tags");
      }
    } catch (error) {
      console.log(error);
      toast.dismiss();
      toast.error(error?.response?.message || "An error occurred");
    }
  };

  useEffect(() => {
    if (!fileUploadModal) {
      setUploadedFile(null);
    }
  }, [fileUploadModal]);

  useEffect(() => {
    currentAgencyLogo = null;
    setCurrentLogo(currentLogo);
  }, [currentLogo]);

  useEffect(() => {
    fetchUsers(agencyId);
  }, [agencyId]);

  const addNewAdmin = useFormik({
    initialValues: {
      email: "",
      password: "",
      username: "",
    },
    validationSchema: Yup.object().shape({
      username: Yup.string().required("Admin name cannot be empty."),
      email: Yup.string()
        .email("Enter a valid email address")
        .required("email cannot be empty.")
        .matches(
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          "Enter a valid email address"
        ),
      password: Yup.string()
        .required("Password cannot be empty.")
        .min(8, "Password must be at least 8 characters long.")
        .matches(
          /[A-Z]/,
          "Password must contain at least one uppercase letter."
        )
        .matches(
          /[a-z]/,
          "Password must contain at least one lowercase letter."
        )
        .matches(/[0-9]/, "Password must contain at least one number.")
        .matches(
          /[!@#$%^&*(),.?":{}|<>]/,
          "Password must contain at least one special character."
        ),
    }),
    onSubmit: async (values) => {
      setIsButtonClicked(true);

      const requestData = { ...values, agencyId };
      const response = await createAdmin(requestData);

      if (response.statuscode === 1) {
        toast.dismiss();
        toast.success(response.message || "Admin Created Successfully");
        addNewAdmin.resetForm();
        setCreateAdminModal(false);
        fetchUsers(agencyId);
      } else {
        toast.dismiss();
        toast.warning(response.message);
      }
      setIsButtonClicked(false);
    },
  });

  const handleDeleteConfirm = async () => {
    if (!selectedUserId) return;
    setIsLoading(true);

    try {
      const result = await deleteAdminCall(selectedUserId?.userid);
      console.log("Delete Result:", result);

      if (result?.statuscode === 1) {
        setUsersData((prevUsers) =>
          prevUsers.filter((user) => user.userid !== selectedUserId)
        );
        setDeleteUser(false);
        toast.dismiss();
        toast.success(result?.message || "Admin Deleted Successfully.");
        fetchUsers(agencyId);
      } else {
        toast.dismiss();
        toast.error("Failed to delete user. Please try again.");
      }
    } catch (error) {
      console.error("Delete Error:", error);
      toast.dismiss();
      toast.error("An error occurred while deleting the user.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseCreateAdmin = () => {
    setCreateAdminModal(false);
    addNewAdmin.resetForm();
  };

  return (
    <div className="p-4">
      <ToastContainer />
      <div
        className="p-3 rounded d-flex justify-content-between w-100 align-items-center shadow"
        style={{ backgroundColor: "#F7F7F8" }}
      >
        <div className="d-flex w-50 gap-3">
          {/* <div> */}
          <div
            style={{ width: 80, height: 80 }}
            className="bg-gray-400 rounded"
          >
            <img
              src={currentLogo || DefaultAgency}
              style={{ width: "100%", height: "100%" }}
              className="rounded"
            />
            <div
              className="position-absolute p-1 justify-content-center d-flex items-content-center"
              style={{
                marginLeft: 49,
                marginTop: -22,
                backgroundColor: "rgba(96, 107, 153, 0.9)",
                width: 22,
                height: 22,
                borderTopLeftRadius: 9,
                borderBottomRightRadius: 8,
                cursor: "pointer",
              }}
            >
              <MdModeEdit
                fontSize={15}
                style={{ color: "white" }}
                onClick={() => setFileUploadModal(true)}
              />
            </div>
            {/* </div> */}
          </div>
          <div className="w-100 d-flex flex-column justify-content-center align-items-start">
            <h4 style={{ color: "#262B40", fontWeight: "bold" }}>
              {currentAgencyData?.agency || "N/A"}
            </h4>
            <h6 style={{ color: "#262B40" }}>
              {currentAgencyData?.address || "N/A"}
            </h6>
          </div>
        </div>
      </div>
      <div className="mt-4 p-3 px-4 rounded-xl shadow-sm mx-3 bg-white">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="d-flex align-items-center">
            <h5
              style={{
                color: "#262B40",
                fontWeight: "bold",
                fontSize: 25,
                paddingTop: 8,
              }}
            >
              User List
            </h5>
          </div>
          <Row>
            <Col md={12} className="d-flex ">
              {!adminExists && (
                <Button
                  variant={currentAgencyData?.isactive ? "primary" : "tertiary"}
                  className="text-white"
                  style={{
                    cursor: currentAgencyData?.isactive
                      ? "pointer"
                      : "not-allowed",
                  }}
                  onClick={
                    currentAgencyData?.isactive
                      ? () => setCreateAdminModal(true)
                      : () => {}
                  }
                >
                  CREATE ADMIN
                </Button>
              )}
            </Col>
          </Row>
        </div>
        <DynamicTable
          cols={cols}
          response={usersData}
          isPaginate={false}
          numberOfData={10}
          headerClass="table-header"
          rowHover={true}
          fixedHeight={false}
          isBgTransparent={false}
          hideHeader={false}
          isloading={isLoading}
        />
      </div>

      <Modal show={createAdminModal} onHide={handleCloseCreateAdmin} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add New Admin</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={addNewAdmin.handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>User Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="User Name"
                name="username"
                value={addNewAdmin.values.username}
                onChange={addNewAdmin.handleChange}
                onBlur={addNewAdmin.handleBlur}
                isInvalid={
                  addNewAdmin.touched.username && addNewAdmin.errors.username
                }
                maxLength={30}
              />
              <Form.Control.Feedback type="invalid">
                {addNewAdmin.errors.username}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Email Address</Form.Label>
              <Form.Control
                type="email"
                placeholder="Email Address"
                name="email"
                value={addNewAdmin.values.email}
                onChange={addNewAdmin.handleChange}
                onBlur={addNewAdmin.handleBlur}
                isInvalid={
                  addNewAdmin.touched.email && addNewAdmin.errors.email
                }
                maxLength={50}
              />
              <Form.Control.Feedback type="invalid">
                {addNewAdmin.errors.email}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Password</Form.Label>
              <div className="position-relative">
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  name="password"
                  value={addNewAdmin.values.password}
                  onChange={addNewAdmin.handleChange}
                  onBlur={addNewAdmin.handleBlur}
                  isInvalid={
                    addNewAdmin.touched.password && addNewAdmin.errors.password
                  }
                  maxLength={30}
                />
                <div
                  className="position-absolute"
                  style={{
                    top: "50%",
                    right: "35px",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                  }}
                  onClick={handleTogglePassword} // Toggle visibility on click
                >
                  <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} />
                </div>
              </div>
              <Form.Control.Feedback type="invalid">
                {addNewAdmin.errors.password}
              </Form.Control.Feedback>
            </Form.Group>

            <Modal.Footer>
              <Button
                type="submit"
                variant="primary"
                className="text-white"
                disabled={isButtonClicked}
              >
                {isButtonClicked ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  "Add Admin"
                )}
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal
        show={fileUploadModal}
        onHide={() => setFileUploadModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {currentAgencyData?.agencylogo &&
            currentAgencyData?.agencylogo !== "null" &&
            currentAgencyData?.agencylogo.trim() !== ""
              ? "Update Agency Logo"
              : "Add Agency Logo"}
            {/* <span style={{ fontWeight: "lighter", fontSize: "20px" }}>
              {selectedAgencyId?.agency}
            </span> */}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="d-flex flex-column align-items-center justify-content-center">
            <Form.Group controlId="fileUpload" className="w-100">
              {!uploadedFile ? (
                <>
                  <Form.Control
                    type="file"
                    // accept=".xlsx"
                    style={{ display: "none" }}
                    id="fileUpload"
                    onChange={handleFileUpload}
                  />
                  <Form.Label
                    className="btn btn-primary w-100 text-center text-gray bg-tertiary border-0"
                    htmlFor="fileUpload"
                  >
                    <FontAwesomeIcon icon={faUpload} className="text-gray" />{" "}
                    Select File
                  </Form.Label>
                </>
              ) : (
                <div className="d-flex flex-column align-items-center w-100">
                  <div className="text-truncate mb-2 w-100 text-center">
                    <strong>Selected File:</strong> {uploadedFile.name}
                  </div>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={handleFileRemove}
                    className="w-50"
                  >
                    <FontAwesomeIcon icon={faTrash} /> Remove
                  </Button>
                </div>
              )}
            </Form.Group>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            type="submit"
            variant="primary"
            className="text-white"
            disabled={isButtonClicked || !uploadedFile}
            onClick={handleSubmit}
          >
            {isButtonClicked ? (
              <Spinner animation="border" size="sm" />
            ) : (
              "Upload"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={deleteUser} onHide={() => setDeleteUser(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete Admin</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure want to delete the Admin ?</Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleDeleteConfirm}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default UsersList;
